import Icon from '../components/Icon.vue'

Icon.register({"coffee":{"width":640,"height":512,"paths":[{"d":"M192 384H384C437 384 480 341 480 288H512C582.6 288 640 230.6 640 160S582.6 32 512 32H120C106.7 32 96 42.7 96 56V288C96 341 139 384 192 384zM512 96C547.3 96 576 124.7 576 160S547.3 224 512 224H480V96H512zM559.7 480H48.3C0.7 480-12.7 416 12.3 416H595.6C620.6 416 607.4 480 559.7 480z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/coffee.js
// module id = FdDz
// module chunks = 0